(function () {
  var THRESHOLD = 5000; // CHF 50 in Rappen

  var styleEl = document.createElement('style');
  styleEl.textContent =
    '.lhg-fsb{border:1px solid #e30613;border-radius:10px;padding:12px 16px;margin:12px 0;font-size:14px;text-align:center;background:#fff5f5;color:#1a1a1a;}' +
    '.lhg-fsb-msg{margin-bottom:8px;font-weight:600;}' +
    '.lhg-fsb-track{height:8px !important;border-radius:99px;background:rgba(0,0,0,.08);overflow:hidden;display:block !important;width:100%;}' +
    '.lhg-fsb-fill{height:8px !important;min-height:8px;width:0;background:#e30613;border-radius:99px;transition:width .4s ease;display:block !important;font-size:0;line-height:0;}' +
    '.lhg-fsb.qualified .lhg-fsb-msg{color:#e30613;}';
  document.head.appendChild(styleEl);

  function fmt(c) { return 'CHF ' + (c / 100).toFixed(2); }

  function update(cart) {
    document.querySelectorAll('.lhg-fsb').forEach(function (bar) {
      var msg = bar.querySelector('.lhg-fsb-msg');
      var fill = bar.querySelector('.lhg-fsb-fill');
      var remaining = THRESHOLD - cart.total_price;
      if (remaining <= 0) {
        msg.textContent = 'Gratisversand freigeschaltet ✓';
        fill.style.width = '100%';
        bar.classList.add('qualified');
      } else {
        msg.textContent = 'Noch ' + fmt(remaining) + ' bis zum Gratisversand';
        fill.style.width = Math.min(100, (cart.total_price / THRESHOLD) * 100) + '%';
        bar.classList.remove('qualified');
      }
    });
  }

  function inject() {
    var product = document.getElementById('cart-notification-product');
    if (!product) return;
    if (product.parentNode.querySelector('.lhg-fsb')) return;
    var bar = document.createElement('div');
    bar.className = 'lhg-fsb';
    bar.innerHTML =
      '<div class="lhg-fsb-msg">Gratisversand ab CHF 50</div>' +
      '<div class="lhg-fsb-track"><div class="lhg-fsb-fill">&nbsp;</div></div>';
    product.parentNode.insertBefore(bar, product);
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(update)
      .catch(function () {});
  }

  var observer = new MutationObserver(function () {
    var product = document.getElementById('cart-notification-product');
    if (product && product.innerHTML.trim().length > 0) {
      inject();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();